import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

export const redirectLangGuard = () => {
  const router = inject(Router);
  const lang = localStorage.getItem('lang') || 'en';
  const currentUrl = router.url;
  const redirectUrl: UrlTree = router.createUrlTree([`/${lang}${currentUrl}`]);

  return redirectUrl;
};
